module.exports = __webpack_public_path__ + "static/sxsw-innovation-award-aae6b2e6abe72cc99900a9290e77953d.svg";